import React, {
  useEffect,
  useState
} from "react";


import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  CircularProgress
} from "@mui/material";


import {
  getRecentTickets
} from "../../services/reportService";






function RecentTickets(){



const [tickets,setTickets] = useState([]);

const [loading,setLoading] = useState(true);






useEffect(()=>{


const loadTickets = async()=>{


try{


const response = await getRecentTickets();


setTickets(response);



}

catch(error){


console.error(

"Recent Tickets Error:",

error

);


}

finally{


setLoading(false);


}


};



loadTickets();


},[]);









const statusColor = (status)=>{


switch(status){


case "Open":

return "#fef3c7";


case "In Progress":

return "#dbeafe";


case "Resolved":

return "#dcfce7";


case "Closed":

return "#e2e8f0";


default:

return "#f1f5f9";


}


};








if(loading){


return (

<Box

display="flex"

justifyContent="center"

alignItems="center"

height="200px"

>

<CircularProgress/>

</Box>

);


}









return (


<Box>


<Typography

sx={{

fontSize:20,

fontWeight:700,

color:"#0f172a",

mb:3,

fontFamily:"Inter, Roboto, Arial"

}}

>

Recent Tickets

</Typography>








<TableContainer

component={Paper}

sx={{

borderRadius:3,

border:"1px solid #e5e7eb",

boxShadow:"none"

}}

>


<Table>






<TableHead>


<TableRow

sx={{

background:"#f8fafc"

}}

>



<TableCell

sx={{fontWeight:600}}

>

Ticket ID

</TableCell>



<TableCell

sx={{fontWeight:600}}

>

Title

</TableCell>



<TableCell

sx={{fontWeight:600}}

>

Category

</TableCell>



<TableCell

sx={{fontWeight:600}}

>

Priority

</TableCell>



<TableCell

sx={{fontWeight:600}}

>

Status

</TableCell>



<TableCell

sx={{fontWeight:600}}

>

Created

</TableCell>



</TableRow>


</TableHead>








<TableBody>



{

tickets.map((ticket)=>(


<TableRow

key={ticket.id}

hover

>





<TableCell>

#{ticket.id}

</TableCell>







<TableCell>


<Typography

fontWeight={600}

fontSize={14}

>

{ticket.title}

</Typography>


</TableCell>







<TableCell>

{ticket.category}

</TableCell>







<TableCell>


<Chip

label={ticket.priority}

size="small"

sx={{

fontWeight:600

}}

/>


</TableCell>







<TableCell>


<Chip

label={ticket.status}

size="small"

sx={{

background:statusColor(ticket.status),

fontWeight:600

}}

/>


</TableCell>







<TableCell>


{

ticket.created

?

new Date(ticket.created)

.toLocaleDateString()

:

"-"

}


</TableCell>







</TableRow>


))


}



</TableBody>



</Table>


</TableContainer>





</Box>


);


}



export default RecentTickets;